var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_6590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.9062C10 17.2657 10.29 17.5293 10.6658 17.5293H15.2179L12.8318 23.8338C12.4844 24.7601 13.4603 25.2577 14.0859 24.5063L21.4708 15.5342C21.6186 15.3431 21.6989 15.1683 21.6989 14.9656C21.6989 14.6061 21.4171 14.3425 21.0332 14.3425H16.481L18.867 8.038C19.2227 7.11176 18.2386 6.61411 17.613 7.36552L10.228 16.3376C10.0803 16.5286 10 16.7035 10 16.9062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_6590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 18,
    fill: "white",
    transform: "translate(10 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostersIcon);
export default __webpack_public_path__ + "static/media/boosters-icon.5fcc350fd601ef86bfd780359fa1471b.svg";
export { ForwardRef as ReactComponent };